<script>
    import { deleteIcon, editIcon } from "../../Utils/utilConstants.svelte";
    import { DirectInsuranceType } from "../../Utils/utilEnums.svelte";
    import { isObjectEmpty } from "../../Utils/utilFunctions.svelte";
    import { user } from "../../stores";
    import { v4 } from "uuid";
    export let icons = [],
        tableType = "",
        row,
        col,
        downloadOnlyStatus,
        showCancelledBanner = false,
        cancelledStatus,
        showPatientInDownload = false,
        hideSendToPatientIcon = false,
        insuranceType;

    $: iconsVisible =
        tableType != "Receipt" || (tableType == "Receipt" && row.status != 7);

    $: showDeleteQuoteIcon =
        (tableType == "Quote" || tableType == "Fee Estimate") &&
        icons.includes("deleteQuoteIcon") &&
        row.status != 9 &&
        (!row.payments || !row.payments.some((payment) => payment.status != 9));

    $: showDeleteInvoiceIcon =
        tableType == "Invoice" &&
        icons.includes("deleteInvoiceIcon") &&
        row.status != 9 &&
        (!row.payments || !row.payments.some((payment) => payment.status != 9));

    $: hideGoToDownloadAndSendToPatientIcon =
        tableTypesRequireConsiderHiddenDownloadAndSendToPatientIcon.includes(
            tableType,
        ) &&
        ((row.payments &&
            Array.isArray(row.payments) &&
            row.payments.some((payment) =>
                paymentStatusRequireHiddenDownloadAndSendToPatientIcon.includes(
                    payment.status,
                ),
            )) ||
            paymentStatusRequireHiddenDownloadAndSendToPatientIcon.includes(
                row.status,
            ));

    $: paymentTableShowSendRefundConfirmationIcon =
        tableType == "Receipt" &&
        ((row.payments &&
            Array.isArray(row.payments) &&
            row.payments.every((payment) => [4].includes(payment.status))) ||
            [4].includes(row.status));

    $: if (downloadOnlyStatus || downloadOnlyStatus === 0)
        filterIconsByStatus(downloadOnlyStatus);

    const tableTypesRequireConsiderHiddenDownloadAndSendToPatientIcon = [
        "Receipt",
    ];
    const paymentStatusRequireHiddenDownloadAndSendToPatientIcon = [4, 5, 9];

    const filterIconsByStatus = (downloadOnlyStatus) => {
        if (row.status === downloadOnlyStatus) icons = ["downloadIcon"];
    };

    const id = v4(),
        mouseOutTrailTime = 150,
        btnClass =
            "btn btn-sm btn-ghost text-primary justify-start w-auto gap-x-[4px] hover:bg-secondary hover:text-white font-normal py-[3px] px-[6px]";

    let positionTop,
        positionBottom,
        positionRight,
        isLinksOpen = false,
        isDownloadsOpen = false;

    const calculatePosition = async (iconName) => {
        let ele = document.getElementById(`${id}-${iconName}`);
        if (ele) {
            let { top, bottom, right, left } = ele.getBoundingClientRect();
            const width = window.innerWidth;
            const height = window.innerHeight;
            const middle = (top + bottom) / 2;

            if (middle > window.innerHeight / 2) {
                positionTop = "auto";
                positionBottom = `${height - middle}px`;
                positionRight = `${width - left}px`;
            } else {
                positionTop = `${middle}px`;
                positionBottom = "auto";
                positionRight = `${width - left}px`;
            }
            if (iconName === "links") {
                isLinksOpen = true;
            }
            if (iconName === "downloads") {
                isDownloadsOpen = true;
            }
        }
    };

    $: isUserEnableViewDoctor = $user.role >= 20;

    $: collapseIcons =
        !$user.settings ||
        isObjectEmpty($user.settings) ||
        !$user.settings.hasOwnProperty("tableActionUseHamburgerIcon")
            ? false
            : $user.settings.tableActionUseHamburgerIcon;

    const hideLinks = () => {
        setTimeout(() => {
            isLinksOpen = false;
        }, mouseOutTrailTime);
    };

    const hideDownloads = () => {
        setTimeout(() => {
            isDownloadsOpen = false;
        }, mouseOutTrailTime);
    };
</script>

{#if iconsVisible}
    <div class="w-auto flex flex-row justify-start gap-x-[8px]">
        {#if showCancelledBanner && cancelledStatus === row.status}
            <div
                class="badge badge-warning py-4 cursor-default text-white font-extrabold tracking-[0.25rem]"
            >
                CANCELLED
            </div>
        {/if}
        {#if collapseIcons}
            {#if tableType != "Fee Estimate"}
                <button
                    class="btn-ghost btn-circle btn-sm"
                    on:mouseenter|preventDefault={() =>
                        calculatePosition("links")}
                    on:mouseleave|preventDefault={hideLinks}
                >
                    <!-- svelte-ignore a11y-missing-attribute -->
                    <a class="rounded-full" id="{id}-links">
                        <i class="fa fa-link"></i>
                    </a>
                    <div
                        class="p-2 bg-base-100 flex-col gap-y-[2px] w-auto shadow-left-xl rounded-[8px] text-[13px] text-primary {isLinksOpen
                            ? 'flex'
                            : 'hidden'}"
                        style="position: fixed; z-index: 100; right: {positionRight}; bottom: {positionBottom}; top: {positionTop}; left: auto"
                    >
                        {#if icons.includes("viewPatientEncounterIcon")}
                            <button class="viewPatientEncounterIcon {btnClass}">
                                <span class="tw-w-[30px] tw-h-[30px]">
                                    <i
                                        class="viewPatientEncounterIcon fa fa-hand-holding-medical"
                                    ></i>
                                </span>
                                View Patient Encounter Details
                            </button>
                        {/if}
                        {#if icons.includes("viewPatientIcon")}
                            <button class="viewPatientIcon {btnClass}">
                                <span class="tw-w-[30px] tw-h-[30px] pr-[3px]">
                                    <i
                                        class="viewPatientIcon fa fa-user-injured"
                                    ></i>
                                </span>
                                View Patient Details
                            </button>
                        {/if}
                        {#if isUserEnableViewDoctor && icons.includes("viewDoctorIcon")}
                            <button class="viewDoctorIcon {btnClass}">
                                <span class="tw-w-[30px] tw-h-[30px] pr-[3px]">
                                    <i class="viewDoctorIcon fa fa-user-doctor"
                                    ></i>
                                </span>
                                View Doctor Details
                            </button>
                        {/if}
                        {#if icons.includes("goToPortalPageIcon")}
                            <button class="goToPortalPageIcon {btnClass}">
                                <span class="tw-w-[30px] tw-h-[30px]">
                                    <i
                                        class="goToPortalPageIcon fa-solid fa-file-signature"
                                    ></i>
                                </span>
                                Go To Portal Page
                            </button>
                        {/if}
                        {#if icons.includes("downloadLinkIcon") && !hideGoToDownloadAndSendToPatientIcon}
                            <button class="downloadLinkIcon {btnClass}">
                                <span class="tw-w-[30px] tw-h-[30px]">
                                    <i
                                        class="downloadLinkIcon fa fa-cloud-download"
                                    ></i>
                                </span>
                                Go To Download Page
                            </button>
                        {/if}

                        {#if icons.includes("sendRefundConfirmationIcon") && paymentTableShowSendRefundConfirmationIcon}
                            <button
                                class="sendRefundConfirmationIcon {btnClass}"
                            >
                                <span class="tw-w-[30px] tw-h-[30px]">
                                    <i
                                        class="sendRefundConfirmationIcon fa-solid fa-house-medical-circle-exclamation"
                                    ></i>
                                </span>
                                Send Refund Confirmation and Request Bank Details
                                of Patient
                            </button>
                        {/if}
                    </div>
                </button>
            {/if}

            <button
                class="btn-ghost btn-circle btn-sm"
                on:mouseenter|preventDefault={() =>
                    calculatePosition("downloads")}
                on:mouseleave|preventDefault={hideDownloads}
            >
                <!-- svelte-ignore a11y-missing-attribute -->
                <a class="rounded-full" id="{id}-downloads">
                    <i class="fa fa-ellipsis-h"></i>
                </a>
                <div
                    class="p-2 bg-base-100 flex-col gap-y-[2px] w-auto shadow-left-xl rounded-[8px] text-[13px] text-primary {isDownloadsOpen
                        ? 'flex'
                        : 'hidden'}"
                    style="position: fixed; z-index: 100; right: {positionRight}; bottom: {positionBottom}; top: {positionTop}; left: auto"
                >
                    {#if showDeleteQuoteIcon && icons.includes("deleteQuoteIcon")}
                        <button class="deleteQuoteIcon {btnClass}">
                            <span class="tw-w-[30px] tw-h-[30px]">
                                <i class={`deleteQuoteIcon ${deleteIcon}`}></i>
                            </span>
                            Delete {tableType == "Quote"
                                ? "Quote"
                                : "Fee Estimate"}
                        </button>
                    {/if}

                    {#if showDeleteInvoiceIcon && icons.includes("deleteInvoiceIcon")}
                        <button class="deleteInvoiceIcon {btnClass}">
                            <span class="tw-w-[30px] tw-h-[30px]">
                                <i class={`deleteInvoiceIcon ${deleteIcon}`}
                                ></i>
                            </span>
                            Delete Invoice
                        </button>
                    {/if}
                    {#if icons.includes("editPaymentIcon")}
                        <button class="editPaymentIcon {btnClass}">
                            <span class="tw-w-[30px] tw-h-[30px]">
                                <i class={`editPaymentIcon ${editIcon}`}></i>
                            </span>
                            Edit Payment
                        </button>
                    {/if}
                    {#if icons.includes("editReceiptIcon")}
                        <button class="editReceiptIcon {btnClass}">
                            <span class="tw-w-[30px] tw-h-[30px]">
                                <i class={`editReceiptIcon ${editIcon}`}></i>
                            </span>
                            Edit Payment
                        </button>
                    {/if}
                    {#if icons.includes("reGenerateIcon")}
                        <button class="reGenerateIcon {btnClass}">
                            <span class="tw-w-[30px] tw-h-[30px]">
                                <i class="reGenerateIcon fas fa-arrows-rotate"
                                ></i>
                            </span>
                            Re-generate {tableType} PDF
                        </button>
                    {/if}
                    {#if icons.includes("printIcon")}
                        <button class="printIcon {btnClass}">
                            <span class="tw-w-[30px] tw-h-[30px]">
                                <i class="printIcon fa-solid fa-print"></i>
                            </span>
                            Get Paper {tableType}
                        </button>
                    {/if}
                    {#if (row.rebate || insuranceType == DirectInsuranceType.Overseascover) && icons.includes("downloadHealthIcon")}
                        <button class="downloadHealthIcon {btnClass}">
                            <span class="tw-w-[30px] tw-h-[30px]">
                                <i class="downloadHealthIcon fa fa-medkit"></i>
                            </span>
                            Download {tableType} for Health Fund
                        </button>
                    {/if}
                    {#if icons.includes("downloadIcon")}
                        <button class="downloadIcon {btnClass}">
                            <span class="tw-w-[30px] tw-h-[30px]">
                                <i class="downloadIcon fas fa-download"></i>
                            </span>
                            Download {showPatientInDownload
                                ? "Patient "
                                : ""}{tableType} PDF
                        </button>
                    {/if}
                    {#if icons.includes("sendToPatientIcon") && !hideGoToDownloadAndSendToPatientIcon && !hideSendToPatientIcon}
                        <button class="sendToPatientIcon {btnClass}">
                            <span class="tw-w-[30px] tw-h-[30px]">
                                <i
                                    class="sendToPatientIcon fa-solid fa-paper-plane"
                                ></i>
                            </span>
                            <!-- Hide "to Patient if insurance type is workCover, trafficAccident, Defence or Public in Private" -->
                            Send {tableType}
                            {insuranceType
                                ? insuranceType < 16 || insuranceType == 20
                                    ? "to Patient"
                                    : ""
                                : "to Patient"}
                        </button>
                    {/if}
                </div>
            </button>
        {:else}
            {#if showDeleteQuoteIcon && icons.includes("deleteQuoteIcon")}
                <div
                    class="deleteQuoteIcon cursor-pointer tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white"
                    data-tip={`Delete ${tableType == "Quote" ? "Quote" : "Fee Estimate"}`}
                >
                    <i class={`deleteQuoteIcon ${deleteIcon}`}></i>
                </div>
            {/if}

            {#if showDeleteInvoiceIcon && icons.includes("deleteInvoiceIcon")}
                <div
                    class="deleteInvoiceIcon cursor-pointer tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white"
                    data-tip="Delete Invoice"
                >
                    <i class={`deleteInvoiceIcon ${deleteIcon}`}></i>
                </div>
            {/if}

            {#if icons.includes("editPaymentIcon")}
                <div
                    class="editPaymentIcon cursor-pointer tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white"
                    data-tip="Edit Payment"
                >
                    <i class={`editPaymentIcon ${editIcon}`}></i>
                </div>
            {/if}

            {#if icons.includes("viewPatientEncounterIcon")}
                <div
                    class="viewPatientEncounterIcon tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white"
                    data-tip={`View ${row.quoteOnly ? 'fee estimate' : 'patient encounter'} details`}
                >
                    <i
                        class="viewPatientEncounterIcon fa fa-hand-holding-medical"
                    ></i>
                </div>
            {/if}
            {#if icons.includes("viewPatientIcon")}
                <div
                    class="viewPatientIcon tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white"
                    data-tip="View patient details"
                >
                    <i class="viewPatientIcon fa fa-user-injured"></i>
                </div>
            {/if}
            {#if isUserEnableViewDoctor && icons.includes("viewDoctorIcon")}
                <div
                    class="viewDoctorIcon tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white"
                    data-tip="View doctor details"
                >
                    <i class="viewDoctorIcon fa fa-user-doctor"></i>
                </div>
            {/if}
            {#if icons.includes("printIcon")}
                <div
                    class="printIcon tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white"
                    data-tip="Get paper {tableType}"
                >
                    <i class="printIcon fa-solid fa-print"></i>
                </div>
            {/if}

            {#if (row.rebate || insuranceType == DirectInsuranceType.Overseascover) && icons.includes("downloadHealthIcon")}
                <div
                    class="downloadHealthIcon cursor-pointer tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white"
                    data-tip="Download {tableType} for Health Fund"
                >
                    <i class="downloadHealthIcon fa fa-medkit"></i>
                </div>
            {/if}

            {#if icons.includes("editReceiptIcon")}
                <div
                    class="editReceiptIcon cursor-pointer tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white"
                    data-tip="Edit Payment"
                >
                    <i class={`editReceiptIcon ${editIcon}`}></i>
                </div>
            {/if}

            {#if icons.includes("reGenerateIcon")}
                <div
                    class="reGenerateIcon cursor-pointer tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white"
                    data-tip="Re-generate {tableType} PDF"
                >
                    <i class="reGenerateIcon fas fa-arrows-rotate"></i>
                </div>
            {/if}
            {#if icons.includes("goToPortalPageIcon")}
                <div
                    class="goToPortalPageIcon cursor-pointer tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white"
                    data-tip="Go To Portal Page"
                >
                    <i class="goToPortalPageIcon fa-solid fa-file-signature"
                    ></i>
                </div>
            {/if}

            {#if icons.includes("downloadLinkIcon") && !hideGoToDownloadAndSendToPatientIcon}
                <div
                    class="downloadLinkIcon cursor-pointer tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white"
                    data-tip="Go To Download Page"
                >
                    <i class="downloadLinkIcon fa fa-cloud-download"></i>
                </div>
            {/if}

            {#if icons.includes("downloadIcon")}
                <div
                    class="downloadIcon cursor-pointer tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white"
                    data-tip="Download {showPatientInDownload
                        ? 'Patient '
                        : ''}{tableType} PDF"
                >
                    <i class="downloadIcon fas fa-download"></i>
                </div>
            {/if}

            {#if icons.includes("sendToPatientIcon") && !hideGoToDownloadAndSendToPatientIcon && !hideSendToPatientIcon}
                <!-- Hide "to Patient if insurance type is workCover, trafficAccident, Defence or Public in Private" -->
                <div
                    class="sendToPatientIcon cursor-pointer tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white"
                    data-tip={`Send ${tableType} ${
                        insuranceType
                            ? insuranceType < 16 || insuranceType == 20
                                ? "to Patient"
                                : ""
                            : "to Patient"
                    }`}
                >
                    <i class="sendToPatientIcon fa-solid fa-paper-plane"></i>
                </div>
            {/if}

            {#if icons.includes("sendRefundConfirmationIcon") && paymentTableShowSendRefundConfirmationIcon}
                <div
                    class="sendRefundConfirmationIcon cursor-pointer tooltip tooltip-secondary tooltip-left flex items-center justify-center w-[30px] h-[30px] hover:rounded-full hover:bg-secondary hover:text-white"
                    data-tip="Send refund confirmation and request bank details to patient"
                >
                    <i
                        class="sendRefundConfirmationIcon fa-solid fa-house-medical-circle-exclamation"
                    ></i>
                </div>
            {/if}
        {/if}
    </div>
{/if}

<style>
    .btn {
        text-transform: capitalize;
        padding: 4px;
    }
</style>
